import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '../lib/analytics.js';

export function RouteTracker() {
  const { pathname } = useLocation();
  useEffect(() => { trackPageview(pathname); }, [pathname]);
  return null;
}
